import HundredBricksAPIError from '../../../HundredBricksAPIError';
class OnSalePropertiesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('OnSalePropertiesError', ...args);
    }
}
export default OnSalePropertiesError;
